import { useState, useEffect } from "react";
import { format } from "date-fns";
import Button from "../../../designSystem/b-molecules/buttons/Button";
import style from "./DateRangePicker.module.css";

const DateRangePicker = ({ startDate, endDate, onDateChange, onClear }) => {
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [error, setError] = useState("");

  // Initialize dates from props
  useEffect(() => {
    if (startDate) {
      const date = startDate instanceof Date ? startDate : new Date(startDate);
      setStart(format(date, "yyyy-MM-dd"));
    } else {
      setStart("");
    }
  }, [startDate]);

  useEffect(() => {
    if (endDate) {
      const date = endDate instanceof Date ? endDate : new Date(endDate);
      setEnd(format(date, "yyyy-MM-dd"));
    } else {
      setEnd("");
    }
  }, [endDate]);

  const handleStartChange = (e) => {
    const newStart = e.target.value;
    setStart(newStart);
    setError("");

    if (newStart && end) {
      const startDateObj = new Date(newStart);
      const endDateObj = new Date(end);
      if (startDateObj > endDateObj) {
        setError("Start date must be before end date");
        return;
      }
    }

    if (newStart) {
      onDateChange({ start: newStart, end: end || null });
    }
  };

  const handleEndChange = (e) => {
    const newEnd = e.target.value;
    setEnd(newEnd);
    setError("");

    if (start && newEnd) {
      const startDateObj = new Date(start);
      const endDateObj = new Date(newEnd);
      if (startDateObj > endDateObj) {
        setError("End date must be after start date");
        return;
      }
    }

    if (newEnd) {
      onDateChange({ start: start || null, end: newEnd });
    }
  };

  const handleClear = () => {
    setStart("");
    setEnd("");
    setError("");
    if (onClear) {
      onClear();
    }
  };

  const today = format(new Date(), "yyyy-MM-dd");

  return (
    <div className={style.dateRangePicker}>
      <div className={style.dateInputs}>
        <div className={style.dateInputGroup}>
          <label htmlFor="start-date">Start Date</label>
          <input
            id="start-date"
            type="date"
            value={start}
            onChange={handleStartChange}
            max={end || today}
            className={error ? style.error : ""}
          />
        </div>
        <div className={style.dateInputGroup}>
          <label htmlFor="end-date">End Date</label>
          <input
            id="end-date"
            type="date"
            value={end}
            onChange={handleEndChange}
            min={start || undefined}
            max={today}
            className={error ? style.error : ""}
          />
        </div>
        <div className={style.clearButton}>
          <Button variants={["text", "small"]} onClick={handleClear}>
            Clear
          </Button>
        </div>
      </div>
      {error && <div className={style.errorMessage}>{error}</div>}
      {start && end && !error && (
        <div className={style.dateRangeDisplay}>
          {format(new Date(start), "MMM dd, yyyy")} - {format(new Date(end), "MMM dd, yyyy")}
        </div>
      )}
    </div>
  );
};

export default DateRangePicker;

